export default "__VITE_ASSET__BrZlJC3u__"